import { SET_IS_THE_OLD_APP_VERSION } from "./types"

export const toggleVersionCheck = (toggle) => dispatch => {
  dispatch({type: SET_IS_THE_OLD_APP_VERSION, payload: toggle})
}